import { telanganaDistrictLabel } from "../data/telanganaDistricts";
import type { MatchedLeadRow } from "./leadsImportGeoMatch";

function trunc(s: string | null | undefined, max: number): string | null {
  if (s == null) return null;
  const t = String(s).trim();
  if (!t) return null;
  return t.length <= max ? t : t.slice(0, max);
}

/** `Leads.Lead_ID` — government application number from the sheet (e.g. 204852/1075289). */
export function leadIdFromApplicationRef(applicationRef: string): string {
  return String(applicationRef ?? "").trim().slice(0, 128);
}

function statusFromMatchedRow(r: MatchedLeadRow): string | null {
  const pieces = [r.listType, r.applicationStatus]
    .map((s) => String(s ?? "").trim())
    .filter((s) => s && s !== "—");
  if (pieces.length) return pieces.join(" · ");
  return "Pending";
}

export type LeadsTableUpsertRow = {
  leadId: string;
  district: string | null;
  mandal: string | null;
  village: string | null;
  applicantName: string | null;
  mobileNumber: string | null;
  aadhaarNumber: string | null;
  status: string | null;
};

/** Build MySQL `Leads` rows from geo-matched import rows (`Lead_ID` = application no). */
export function buildLeadsTablePayloadFromMatched(matched: MatchedLeadRow[]): LeadsTableUpsertRow[] {
  const out: LeadsTableUpsertRow[] = [];
  for (const r of matched) {
    const leadId = leadIdFromApplicationRef(r.applicationRef);
    if (!leadId) continue;
    out.push({
      leadId,
      district: trunc(telanganaDistrictLabel(r.districtKey), 50),
      mandal: trunc(r.canonicalMandal, 50),
      village: trunc(r.canonicalVillage, 50),
      applicantName: trunc(r.applicantName, 50),
      mobileNumber: trunc(r.mobile.replace(/\D/g, ""), 50),
      aadhaarNumber: trunc(r.aadhaarDigits.replace(/\D/g, ""), 50),
      status: trunc(statusFromMatchedRow(r), 50),
    });
  }
  return out;
}
